import { useState } from 'react';
import { faqItems } from '@/mocks/siteData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
              常见问题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              关于「姐姐的朋友」的常见疑问与解答
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqItems.map((item, i) => (
              <div
                key={i}
                className="border border-background-200/70 rounded-lg overflow-hidden bg-background-50"
              >
                <button
                  onClick={() => toggle(i)}
                  className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer"
                >
                  <h3 className="font-heading text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {item.question}
                  </h3>
                  <i
                    className={`text-foreground-500 text-lg flex-shrink-0 transition-transform duration-200 ${
                      openIndex === i ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === i ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}